import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_USUARIOS = 'ALL_USUARIOS';
export const LOADING_ALL_USUARIOS = 'LOADING_ALL_USUARIOS';
export const ACTIVO_USUARIOS = 'ACTIVO_USUARIOS';
export const PARAMS_USUARIOS = 'PARAMS_USUARIOS';
export const GET_ENTIDADES_USUARIOS = 'GET_ENTIDADES_USUARIOS';

const initialState = {
  all: [],
  loadingAll: false,
  pagination: {
    currentPage: 1,
    itemCount: 1,
    itemsPerPage: 50,
    totalItems: 1,
    totalPages: 1,
  },
  activo: null,
  params: {
    page: 1,
    limit: 50,
  },
};

export const usuariosReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_USUARIOS:
      return {
        ...state,
        all: action.payload?.data ?? state.all,
        pagination: action.payload?.meta ?? state.pagination,
      };
    case LOADING_ALL_USUARIOS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_USUARIOS:
      return {
        ...state,
        activo: action.payload,
      };
    case GET_ENTIDADES_USUARIOS:
      return {
        ...state,
        entidades: action.payload,
      };
    case PARAMS_USUARIOS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
